import { render, staticRenderFns } from "./aiAssistant.vue?vue&type=template&id=6f392724&scoped=true"
import script from "./aiAssistant.vue?vue&type=script&lang=js"
export * from "./aiAssistant.vue?vue&type=script&lang=js"
import style0 from "./aiAssistant.vue?vue&type=style&index=0&id=6f392724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_css-loader@6.11.0_webpack@5.105.4_postcss@8_1c589529f38c151ee6d6ea179149c54b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f392724",
  null
  
)

export default component.exports